import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import Home from "@/pages/Home";
import FindOpportunities from "@/pages/FindOpportunities";
import WhatWeBuild from "@/pages/WhatWeBuild";
import HowWeWork from "@/pages/HowWeWork";
import Questions from "@/pages/Questions";
import Book from "@/pages/Book";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import { scrollToHash } from "@/lib/scrollToHash";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prev = useRef(typeof document !== "undefined" && document.referrer ? "external" : "direct");
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      if (!scrollToHash(hash)) window.scrollTo(0, 0);
    });

    if (pathname === "/book") {
      sessionStorage.setItem("bookingSource", prev.current || "direct");
    } else {
      prev.current = pathname;
    }

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-paper text-ink">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pb-14 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/find-opportunities" element={<FindOpportunities />} />
            <Route path="/what-we-build" element={<WhatWeBuild />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/book" element={<Book />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
